export enum ModalState {
  None = 'None',
  Help = 'Help',
  UserPreferences = 'UserPreferences',
  SessionTime = 'SessionTime'
}
